// Health Cross Logo Component - Like HP symbol in video games
export const HealthCrossLogo = ({ className = "w-10 h-10", iconClassName = "" }) => {
  return (
    <div className={`rounded-full bg-primary flex items-center justify-center ${className}`}>
      <svg 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={`text-primary-foreground ${iconClassName || 'w-6 h-6'}`}
      >
        {/* Health Cross - like HP symbol */}
        <path 
          d="M12 4V20M4 12H20" 
          stroke="currentColor" 
          strokeWidth="4" 
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

// Larger version for landing page
export const HealthCrossLogoLarge = ({ className = "" }) => {
  return (
    <div className={`w-20 h-20 md:w-24 md:h-24 rounded-full bg-primary flex items-center justify-center shadow-xl ${className}`}>
      <svg 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="w-12 h-12 md:w-14 md:h-14 text-primary-foreground"
      >
        {/* Health Cross - like HP symbol */}
        <path 
          d="M12 4V20M4 12H20" 
          stroke="currentColor" 
          strokeWidth="4" 
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
